export default __webpack_public_path__ + "static/media/404.c8938c4b.png";